<style scoped>
input[type="text"],
input[type="password"],
input[type="email"],
input[type="date"] {
  height: 38px;
  width: 100%;
  border: none;
  outline: 0;
  border-bottom: 0.3px solid rgba(192, 192, 192, 0.616);
  font-size: 16px;
  background-color: rgba(249, 249, 249);
  padding: 5px;
  font-weight: 500;
  border-radius: 3px;
}
input:focus {
  border-bottom: 2px solid rgba(68, 102, 242);
  padding: 13px;
}
.input-text select option:nth-child(1) {
  display: none !important;
}
</style>

<template>
  <div :class="devClass">
    <input :type="type" :placeholder="title" value="" :class="inputClass" />
  </div>
</template>
<script>
export default {
  props: {
    type: "text",
    devClass: "",
    inputClass: "",
    title: "Vous n'avez défini de title",
  },
};
</script>
